import React from "react"
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Button,
  Box,
} from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { useTheme } from "@mui/material/styles"

import { track } from "../../utils/analytics"

type Props = {
  children: React.ReactNode
}

const HowToGetLicenseWrapper = ({ children }: Props) => {
  const theme = useTheme()

  return (
    <Accordion
      sx={{ textAlign: "center" }}
      onChange={(event, expanded) => {
        if (expanded) {
          track("How To Get License Section Opened")
        }
      }}
    >
      <AccordionSummary
        sx={{ background: theme.palette.secondary.main }}
        expandIcon={<ExpandMoreIcon />}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Typography sx={{ fontWeight: "bold" }}>
            Not sure how to get your license?
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            sx={{ ml: 2, borderRadius: 4 }}
          >
            Expand to View
          </Button>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 0 }}>{children}</AccordionDetails>
    </Accordion>
  )
}

export default HowToGetLicenseWrapper
